angular.module("app").controller("PagesEditItemPageController", [
    '$scope',
    'preloadedItemData',
    'pageStatuses',
    'cropperService',
    'errorHandler',
    'logger',
    'pagesService',
    '$stateParams',
    'settingsService',
    'deepCompare',
    'userStorage',
    'categoryService',
    'aligns',
    'targets',
    '$state',
    '$timeout',
    'slugNameResolver',
    'parentPageIds',
    '$rootScope',
    '$filter',
    'Utils',
    'booleanType',
    'liveDealerClasses',
    '$uibModal',
    'isChangeVersionPageSlug',
    'hiddenGamesService',
    'bannerShowFor',
    'pagesContentRequired',
    'newWindow',
    'androidAppPromoLogoURL',
    'promoDevice',
    'countryCodes',
    'jackpotSources',
    function ($scope, preloadedItemData, pageStatuses, cropperService, errorHandler, logger, pagesService, $stateParams, settingsService, deepCompare, userStorage, categoryService, aligns, targets, $state, $timeout, slugNameResolver, parentPageIds, $rootScope, $filter, Utils, booleanType, liveDealerClasses, $modal, isChangeVersionPageSlug, hiddenGamesService, bannerShowFor, pagesContentRequired, newWindow, androidAppPromoLogoURL, promoDevice, countryCodes, jackpotSources) {


        var settings = settingsService.getSettings(),
            init;
        var categoryTitleIdMap = {};
        var tagTitleIdMap = {};
        $scope.authValues = bannerShowFor.values;
        $scope.isChangeVersionPageSlug = isChangeVersionPageSlug;
        $scope.booleanType = booleanType;
        $scope.liveDealerClasses = liveDealerClasses;
        $scope.newWindow = newWindow;
        $scope.countryCodes = countryCodes.data;
        $scope.countryCodes2 = angular.copy(countryCodes.data);
        $scope.jackpotSources = jackpotSources;

        $scope.parentPageName = preloadedItemData.page.name;
        $scope.showIdAutocomplete = true;
        $scope.tagsTitles = [];
        var initialTags;
        $scope.backgroundSize = {};
        $scope.userData = userStorage.getUserData();
        $scope.languages = settings.skin.languages;
        $scope.switches = {};
        $scope.pagesContentRequired = pagesContentRequired;
        $scope.isNameAutocomplete = preloadedItemData.autocomplete;
        $scope.androidAppPromoLogoURLS = androidAppPromoLogoURL;
        $scope.calledCount = 0;


        var initialCategories;
        function initNames(preloadedPageData) {
            $scope.actualPageNames = angular.copy(preloadedPageData.names || preloadedPageData.pageNames) || null;
            $scope.usedNames = {};
            preloadedPageData.used && preloadedPageData.used.forEach(function (item) {
                $scope.usedNames[item] = true;
            });
            $scope.isNameAutocomplete && $scope.autocomplete && $scope.autocomplete.updateOriginalNames && $scope.autocomplete.updateOriginalNames();

        }
        initNames(preloadedItemData);

        function initImage(item){
            $scope.initialImage = item.image;
        }
        initImage(preloadedItemData.item);

        var typePermissions = {
            'sidebar': 'manageBanners',
            'news': 'manageNews',
            'promo': 'managePromotions',
            'text': 'managePages'
        };

        function getCustomFields(slugName, isEmptyFields) {
            pagesService.getCustomFields(slugName).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.customFields = response.fields;
                        $scope.customFieldTypes = response.types;
                        $scope.customFieldRules = response.rules;
                        if ($scope.customFieldRules) {
                            Object.keys($scope.customFieldRules).forEach(function (key) {
                                $scope.tooltip[key] = "";
                            })
                        }
                        var customeFieldsLength =  $scope.customFields.length;
                        if (isEmptyFields) {
                            $scope.pageData.customFields = [];
                            for(var i = 0; i < customeFieldsLength; ++i){
                                $scope.pageData.customFields.push({
                                        key: $scope.customFields[i],
                                        value: "",
                                    }
                                )
                            }
                        }else {
                            var customFieldsChildren = [];
                            var customFields = $scope.pageData.customFields.children || $scope.pageData.customFields;
                            for(var i = 0; i < customeFieldsLength; ++i){
                                var field = $scope.customFields[i];
                                var filteredItems = customFields.filter(function (value) {
                                    return value.key === field;
                                });
                                if (filteredItems.length > 0) {
                                    delete filteredItems[0].children;
                                    customFieldsChildren.push(filteredItems[0]);
                                } else {
                                    customFieldsChildren.push({
                                            key: field,
                                            value: "",
                                        }
                                    )
                                }
                            }
                            $scope.pageData.customFields = customFieldsChildren;
                            preloadedItemData.item.customFields = angular.copy(customFieldsChildren);
                        }


                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            );
        }


        var notPreview = false;

        $scope.aligns = aligns;
        $scope.targets = targets;
        var goToState = {
            "sidebar": "main.pages.list.banners",
            "category": "main.pages.list.categories",
            "news": "main.pages.list.news",
            "promo": "main.pages.list.promos"
        };

        (init = function () {
            var CUSTOM_FIELD_CUSTOM_NAME = "live-c-slider";

            $scope.tooltip = {
                "pageTitle": "",
                "description": "",
                "pageName": ""
            };
            preloadedItemData.item.meta_description = preloadedItemData.item.meta_description || "";
            preloadedItemData.item.first_deposit = !!preloadedItemData.item.first_deposit;
            $scope.newImageUploaded = null;
            if (preloadedItemData.item.is_optinable  !== undefined) {
                preloadedItemData.item.is_optinable = preloadedItemData.item.is_optinable === '1';
            }
            if ({'sidebar': 1, 'promo': 1, 'text': 1}[preloadedItemData.page.type]) {
                preloadedItemData.item.excluded_countries = preloadedItemData.item.excluded_countries || [];
                preloadedItemData.item.included_countries = preloadedItemData.item.included_countries || [];
            }
            $scope.pageData = angular.copy(preloadedItemData.item);


            $scope.preloadedItemName = $scope.pageData.name;

            if ($scope.parentPageName === CUSTOM_FIELD_CUSTOM_NAME) {
                getCustomFields($scope.parentPageName);
            } else if (!$scope.actualPageNames) {
                var slugName = slugNameResolver.getSlugName($stateParams.pageId);
                if (slugName !== undefined){
                    getCustomFields(slugName);
                } else {
                    getCustomFields($scope.parentPageName);
                }
            }else if ($scope.isNameAutocomplete){
                getCustomFields(preloadedItemData.page.actualNamesPath.split("pageType=")[1]);
            }else {
                getCustomFields($scope.pageData.name);
            }
            $scope.categoryOptions = {
                page_id: $scope.pageData.categoryPageId,
                categories: $scope.pageData.categories && $scope.pageData.categories.map(function (item) {
                    return item.title;
                })
            };

            initialCategories =  angular.copy($scope.categoryOptions.categories);
            $scope.page = preloadedItemData.page;
            if ($scope.page.type === 'promo') {
                if ($scope.pageData.device === undefined) {
                    $scope.pageData.device = promoDevice[0].value;
                }

                $scope.promoDevices = promoDevice;
            }
            $scope.permission = typePermissions[$scope.page.type];
            $scope.pageStatuses = pageStatuses;
            $scope.vm = {
                dateTimeFrom: $scope.pageData.start_date  || "",
                dateTimeTo: $scope.pageData.end_date || "",
                created_at: $scope.pageData.created_at || ""
            };
            $scope.languages = settings.skin.languages;
            $scope.draggedImageDataUrl = "";
            $scope.optionalSettings = {
                hideLanguages: false
            };
            $scope.tagsOptions = {
                allTags: [],
                tags: angular.copy($scope.pageData.tags || []).map(function (item) {
                    return item.title;
                })
            };
            initialTags = angular.copy($scope.tagsOptions.tags);
            $scope.pageData.lang = $scope.pageData.lang || $scope.page.lang;
            if($scope.page.type === 'sidebar') {
                $scope.pageData.show_for = $scope.pageData.show_for || bannerShowFor.defaultValue;
            }
            preloadedItemData.item.lang = preloadedItemData.item.lang || $scope.page.lang;
            $scope.globalOptions = {
                isGlobalActionsAllowed: settings.allowGlobalActions
            };

            if ($scope.page.type == "sidebar") {
                $scope.preloadedShowInCountries = preloadedItemData.item.show_in_countries;
            }

            if ($scope.page.type === 'text' || $scope.page.type === 'sidebar'){
                var pageIds = angular.copy(parentPageIds.parents).reverse();
                pageIds.push($stateParams.pageId);
                $rootScope.breadcrumb = {
                    title: "breadcrumb.pages.edit",
                    url: "#/pages/pageId/edit/detailed",
                    pageIds: pageIds,
                    itemTitle: "breadcrumb.pages.editItem",
                    itemURL: "#/pages/pageId/edit/detailed/itemId".replace('pageId', $stateParams.pageId).replace('itemId', $stateParams.itemId)
                };

                $scope.$on("$destroy", function (event) {
                    $rootScope.breadcrumb = undefined;
                });
                if (!$scope.isNameAutocomplete && $scope.actualPageNames && $scope.actualPageNames.length) {
                    $scope.$watch("pageData.name", function (newValue, oldValue) {
                        if (!newValue && oldValue) {
                            $scope.pageData.name = oldValue;
                        }
                    })
                }
            }
            $scope.autocomplete = {};
        })();

        !$scope.pageData.customFields && ($scope.pageData.customFields = {
            parent: true,
            children: [

            ]
        });

        $scope.allPages = [];
        if ($scope.page.type === "news" || $scope.page.type === "promo") {
            pagesService.getCategories({lang: preloadedItemData.page.lang, type: "category"}).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.allCategories = angular.copy(response.pages);
                        $("categorySelect").trigger('chosen:updated');

                        var nameMap = {
                            "news": "get_category_index",
                            "promo": "promo"
                        };
                        var currentCategory = $scope.allCategories.filter(function (item) {
                            if (item.name === nameMap[$scope.page.type]) {
                                return true;
                            }
                            return false;
                        });
                        $scope.categoryOptions.page_id = currentCategory.length > 0? currentCategory[0].id: null;
                        if($scope.categoryOptions.page_id) {
                            $scope.handleChangeOfCategory($scope.categoryOptions.page_id);
                        }
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            );
            if ($scope.page.type === 'news') {
                settings.allowGlobalActions && categoryService.getTags({page_id: $scope.page.id}).then(
                    function (response) {
                        if (response.status == "ok") {
                            $scope.tagsTitles = angular.copy(response.items).map(function (item) {
                                tagTitleIdMap[item.title] = item.id;
                                return item.title;
                            });
                            $("tagsSelect").trigger('chosen:updated');

                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                )
            }

        } else if ($scope.page.type == "text") {
            pagesService.getCloserPages({id: $stateParams.itemId}).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.allPages = angular.copy(response.pages);
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (error) {
                    errorHandler(error.message);
                }
            )
        }

        $scope.submitEditPageItemForm = function () {
            if (!$scope.edit_page_item_form.$valid) {
                $scope.isSavePressed = true;
                if (($scope.pageData.type === 'news' || $scope.pageData.type === 'promo') && $scope.categoryOptions.categories.length === 0) {
                    $scope.tooltip.categories = 'validationErrorMessages.fieldRequired';
                }
                return;
            } else if ($scope.getChanges()) {
                logger.logError("global.no_changes");
                return;
            } else {
                $scope.isSavePressed = false;
            }
            $scope.preview(function (dataUrl) {
                if (notPreview) {
                    return;
                }

                if ($scope.getChanges($scope.optionalSettings.hideLanguages)) {
                    return logger.logError("global.no_changes")
                }

                delete $scope.pageData.forceTOChange;
                var requestObj = {
                        item: angular.copy($scope.pageData)
                    },
                    changes;
                if (requestObj.item.is_optinable !== undefined) {
                    requestObj.item.is_optinable = requestObj.item.is_optinable? 1: 0;
                }

                requestObj.item.page_id = $stateParams.pageId;
                requestObj.item.content = requestObj.item.content && requestObj.item.content.replace(/&nbsp;|\u00a0/g, " ");
                requestObj.item.customFields = requestObj.item.customFields.filter(function (item) {
                    return !!item.value;
                });
                requestObj.item.categories = $scope.categoryOptions.categories && $scope.categoryOptions.categories.map(function (title) {
                    return categoryTitleIdMap[title];
                });
                if ($scope.tagsOptions.tags.length > 0 && $scope.page.type === 'news') {
                    requestObj.item.tags = $scope.tagsOptions.tags.map(function (value) {
                        return tagTitleIdMap[value];
                    });
                }
                if (requestObj.item.show_for === '1'){
                    requestObj.item.first_deposit = !!requestObj.item.first_deposit;
                } else {
                    delete requestObj.item.first_deposit;
                }


                if ($scope.page.type != "text" && $scope.page.type != "category") {
                    delete requestObj.item.name
                }
                if ($scope.page.type === "sidebar" || $scope.page.type === "text" || $scope.page.type === "news" || $scope.page.type === "promo") {
                    !!$scope.vm.fromDate ? (requestObj.item.start_date = $scope.vm.fromDate) : ($scope.fromDateChanged && (requestObj.item.start_date = false));
                    !!$scope.vm.toDate ? (requestObj.item.end_date = $scope.vm.toDate) : ($scope.toDateChanged && (requestObj.item.end_date = false));
                }


                if (!{'sidebar': 1, 'text':1}[$scope.page.type]) {
                    delete requestObj.item.action;
                    delete requestObj.item.align;
                    delete requestObj.item.video_link;
                    delete requestObj.item.linktarget
                }

                if (dataUrl != $scope.draggedImageDataUrl) {
                    if (!$scope.draggedImageDataUrl && !dataUrl && !!requestObj.item.image) {
                        requestObj.item.image = dataUrl || requestObj.item.image;
                    } else {
                        requestObj.item.image = dataUrl || "";
                    }
                }

                if (!$scope.newImageUploaded && !$scope.cropped && $scope.calledCount <= 2) {
                    delete requestObj.item.image
                }

                if (!!$scope.imageToLoad && !!$scope.imageToLoad.fileUrl && !$scope.cropped) {
                    delete requestObj.item.image;
                    requestObj.item.media_id = $scope.imageToLoad.id
                }

                if ($scope.imageDeleted) {
                    requestObj.item.image = false;
                }

                changes = deepCompare.getChanges(angular.copy(preloadedItemData.item), requestObj.item, false, {});

                if (!angular.equals(changes.customFields, requestObj.item.customFields)) {
                    changes.customFields = requestObj.item.customFields
                }
                if (preloadedItemData.item.categories && !Utils.isArraysEqual(preloadedItemData.item.categories.map(function (item) {
                    return item.id;
                }), requestObj.item.categories)) {
                    changes.categories = requestObj.item.categories;
                } else {
                    delete changes.categories;
                }

                if ($scope.tagsOptions.tags.length > 0 && $scope.page.type === 'news' && !Utils.isArraysEqual(preloadedItemData.item.tags.map(function (item) {
                    return item.id;
                }), requestObj.item.tags)) {
                    changes.tags = requestObj.item.tags;
                } else {
                    delete changes.tags;
                }

                if ({'sidebar': 1,'promo':1, 'text': 1}[$scope.page.type] ){
                    changes.excluded_countries = requestObj.item.excluded_countries;
                    changes.included_countries = requestObj.item.included_countries;
                }

                changes.id = requestObj.item.id;
                changes.page_id = requestObj.item.page_id;

                pagesService.updatePageItem({item: changes}).then(
                    function (response) {
                        if (response.status == "ok") {
                            if (!!preloadedItemData.page.actualNamesPath) {
                                pagesService.getByExternalPath(preloadedItemData.page.actualNamesPath, {page_id: preloadedItemData.page.id}).then(function (namesResponse) {
                                    initNames(namesResponse);
                                    $("#nameSelect").trigger('chosen:updated');
                                });
                            }
                            logger.logSuccess("global.updated");
                            $scope.fromDateChanged = false;
                            $scope.toDateChanged = false;
                            $scope.imageDeleted = false;
                            initialCategories = angular.copy($scope.categoryOptions.categories);
                            initialTags = angular.copy($scope.tagsOptions.tags);
                            $scope.preloadedItemName = $scope.pageData.name;
                            pagesService.getPageItemById({page_id: $stateParams.pageId, id: $stateParams.itemId}).then(function (response) {
                                $scope.pageData.image = response.item.image;
                                initImage(response.item);
                                preloadedItemData.item = angular.copy($scope.pageData);
                                $scope.draggedImageDataUrl = $scope.draggedImage = $scope.cropped = undefined;
                                $scope.calledCount = 0;
                                $scope.newImageUploaded = false;
                                Utils.getBlob($scope.pageData.image, $scope.load);

                            })

                        }
                        else {
                            if(response.message && response.message.page_id) {
                                var modalInstance = $modal.open({
                                    templateUrl: "views/templates/modals/editPageItem.html",
                                    controller: "EditPageItemModalController",
                                    resolve: {
                                        parentPageId: function () {
                                            return $stateParams.pageId;
                                        },
                                        pageId: function () {
                                            return response.message.page_id
                                        }
                                    }
                                });
                            } else {
                                errorHandler(response.message)
                            }
                        }
                    },
                    function (error) {
                        errorHandler(error.message);
                    }
                );
            });
        };

        $scope.handleChangeOfDateTimePicker = function (dateTime, dateToSave) {
            if (this.from) {
                $scope.vm.dateTimeFrom = dateTime;
                $scope.fromDateChanged = true;
                $scope.vm.fromDate = dateToSave || undefined;
                $scope.pageData.start_date = $scope.vm.fromDate;
            } else {
                $scope.vm.dateTimeTo = dateTime;
                $scope.toDateChanged = true;
                $scope.vm.toDate = dateToSave || undefined;
                $scope.pageData.end_date = $scope.vm.toDate;
            }
        };

        $scope.handleChangeOfStartDate = function (dateTime, dateToSave) {
            if ($scope.vm.created_at != dateTime) {
                $scope.vm.created_at = dateTime;
                $scope.createdAtChanged = true;
                $scope.vm.createdAt = dateToSave || undefined;
                $scope.pageData.created_at = $scope.vm.created_at;
            }
        };

        $scope.handleChangeOfCategory = function (pageId, callback) {
            pagesService.groupCategory({page_id: pageId, count: "all", status: 'published'}).then(
                function (response) {
                    if (response.status == "ok") {
                        $scope.categoryItems = angular.copy(response.items);
                        categoryTitleIdMap = {};
                        $scope.categoryItemTitles = $scope.categoryItems.map(function (item) {
                            categoryTitleIdMap[item.title] = item.id;
                            return item.title;
                        });
                        callback && callback();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.getChanges = function (dontShowAnymore) {
            if (dontShowAnymore) {
                return true
            }
            if ($scope.newImageUploaded || $scope.cropped || $scope.calledCount > 2 || $scope.imageDeleted) {
                return false
            }
            if(($scope.page.type === 'news' || $scope.page.type === 'promo') && !deepCompare.isEqual(initialCategories, $scope.categoryOptions.categories)){
                return false;
            }
            if($scope.page.type === 'news' && !deepCompare.isEqual(initialTags, $scope.tagsOptions.tags)){
                return false;
            }
            var copyOfPageData = angular.copy($scope.pageData);
            copyOfPageData.customFields && (copyOfPageData.customFields = copyOfPageData.customFields.filter(function (item) {
                return !! item.value;
            }));
            var copyOfPreloadedData = angular.copy(preloadedItemData.item);
            Array.isArray(copyOfPreloadedData.customFields) && (copyOfPreloadedData.customFields = copyOfPreloadedData.customFields.filter(function (item) {
                return !! item.value;
            }));
            return deepCompare.isEqual(copyOfPageData, copyOfPreloadedData);
        };

        $scope.onCategoryItemSelect
            = $scope.onCategoryItemDeselect
            = $scope.onCategorySelectAll
            = $scope.onCategoryUnselectAll
            = $scope.onTagsItemSelect
            = $scope.onTagsItemDeselect
            = $scope.onTagsSelectAll
            = $scope.onTagsUnselectAll
            = function () {
            $scope.pageData.forceTOChange = true
        };

        if ($scope.pageData.categoryPageId) {
            $scope.handleChangeOfCategory($scope.pageData.categoryPageId);
        }

        function getSelectedCategories(categories, fromArray) {
            var returnArray = [],
                index = 0;

            while (categories[index]) {
                if (!fromArray) {
                    returnArray.push(categories[index].id);
                } else {
                    returnArray.push(categories[index])
                }
                index++
            }
            return returnArray
        }

        function getCurrentCategories () {
            var i = 0,
                changes = [];

            var selectedCategoriesArray = getSelectedCategories($scope.categoryOptions.categories);

            while (selectedCategoriesArray[i]) {
                changes[i] = getCategoryFromList(selectedCategoriesArray[i]);
                i++;
            }

            return angular.copy(changes);
        }

        function getCurrentTags () {
            var i = 0,
                changes = [];

            var selectedTagsArray = getSelectedCategories($scope.tagsOptions.tags);

            while (selectedTagsArray[i]) {
                changes[i] = getTagFromList(selectedTagsArray[i]);
                i++;
            }

            return angular.copy(changes);
        }

        function getCategoryFromList (id) {
            var i = 0;
            while ($scope.categoryItems[i]) {
                var item = $scope.categoryItems[i];
                if (item["id"] == id) {
                    return {
                        id: item["id"],
                        title: item["title"]
                    }
                }
                i++;
            }
            return {}
        }

        function getTagFromList (id) {
            var i = 0;
            while ($scope.tagsOptions.allTags[i]) {
                var item = $scope.tagsOptions.allTags[i];
                if (item["id"] == id) {
                    return {
                        id: item["id"],
                        title: item["title"]
                    }
                }
                i++;
            }
            return {}
        }

        cropperService.call($scope);

        $scope.deleteImage = function () {
            $scope.draggedImageDataUrl = $scope.draggedImage = $scope.cropped = undefined;
            $scope.imageDeleted = true;
            $scope.imageToLoad = undefined;
            $scope.pageData.image = "";
            $scope.initialImage = undefined;
        }
        /**
         * Close edit page
         */
        $scope.closeEditPage = function closeEditPage () {
            notPreview = true;
            if($scope.page.type === 'text' || $scope.page.type === 'sidebar'){
                $state.go('main.pages.editDetailed', {
                    pageId: $scope.page.id
                });
            }else {
                $state.go(goToState[$scope.page.type]);
            }
        }
        /**
         * Name change listener function
         */
        $scope.nameChange = function () {
            getCustomFields($scope.pageData.name, true);
        };

        /**
         * Remove media image when browsing new image
         */
        $scope.removeMediaImage = function removeMediaImage() {
            $scope.imageToLoad = undefined;
            $scope.initialImage = undefined;
        }

        /**
         * Adding checking for categories is empty then select making required error
         */
        $scope.checkCategoriesIsEmpty = function checkCategoriesIsEmpty() {
            $scope.edit_page_item_form.categories.$setValidity("categoryNotSelected", $scope.categoryOptions.categories.length > 0);
            if ($scope.categoryOptions.categories.length === 0){
                $scope.tooltip.categories = 'validationErrorMessages.fieldRequired';
            } else {
                $scope.tooltip.categories = '';
            }
        }
        /**
         * Initialize categories state
         */
        $scope.initForm = function initForm() {
        }


        $scope.$watch("imageToLoad", function (newVal, oldVal) {
            if(newVal && newVal !== oldVal){
                Utils.getBlob($scope.imageToLoad.fileUrl, $scope.load);
                $scope.initialImage = undefined;
            }
        });

        /**
         * Handle switch type custom field change
         * @param $index custom field index
         * @param field name
         */
        $scope.handleSwitchChange = function handleSwitchChange($index, field) {
            $scope.pageData.customFields[$index].value = $scope.switches[field]? "1": "";
        };

        /**
         * Manage categories in news and promo section
         */
        $scope.manageCategories = function manageCategories() {
            var isInitiallyEmpty = $scope.categoryOptions.categories.length === 0;
            var categoryTitleIdMapCopy = angular.copy(categoryTitleIdMap);
            var processResponse = function () {
                $scope.handleChangeOfCategory($scope.categoryOptions.page_id, function () {
                    var reversedCategoryTitleIdMap = Utils.createReverse(categoryTitleIdMap);
                    $scope.categoryOptions.categories = $scope.categoryOptions.categories.map(function (value) {
                        return reversedCategoryTitleIdMap[categoryTitleIdMapCopy[value]];
                    });
                    $scope.categoryOptions.categories = $scope.categoryOptions.categories.filter(function (value) {
                        return categoryTitleIdMap[value] !== undefined;
                    });
                    !isInitiallyEmpty && ($scope.checkCategoriesIsEmpty());
                    $("#categorySelect").trigger('chosen:updated');
                });
            };
            $modal.open({
                templateUrl: "views/pages/manageCategories.html",
                controller: "PagesManageCategoriesController",
                resolve: {
                    categoryPageId: function() {
                        return $scope.categoryOptions.page_id
                    },
                    language: function () {
                        return $scope.pageData.lang;
                    },
                    preloadedCategories: function () {
                        return pagesService.getPageItems({page_id: $scope.categoryOptions.page_id, limit: 25, status: 'published'}).then(
                            function (response) {
                                if (response.status == "ok") {
                                    if (!!response.page.actualNamesPath) {
                                        return pagesService.getByExternalPath(response.page.actualNamesPath, {page_id: $scope.categoryOptions.page_id}).then(
                                            function (namesResponse) {
                                                if (namesResponse.status === "ok") {
                                                    var result = angular.copy(response);
                                                    result.names = angular.copy(namesResponse.pageNames);
                                                    result.used = namesResponse.used;
                                                    return angular.copy(result)
                                                } else {
                                                    return angular.copy(response)
                                                }

                                            },
                                            function () {
                                                return angular.copy(response)
                                            }
                                        )
                                    }
                                    return angular.copy(response);
                                } else {
                                    errorHandler(response.message)
                                }
                            },
                            function (response) {
                                errorHandler(response.message)
                            }
                        )
                    }
                }
            }).result.then(processResponse, processResponse);
        };
        /**
         * Increment version
         */
        $scope.sendNotification = function sendNotification() {
            $modal.open({
                templateUrl: "views/templates/modals/confirmPageChangesForAllLanguages.html",
                controller: "ConfirmDeleteActionModalController"
            }).result.then(function () {
                pagesService.incrementVersion($scope.pageData.id).then(function (response) {
                        if (response.status == "ok") {
                            logger.logSuccess("global.updated");
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                );
            })
        };

        /**
         * Load providers for select custom field
         */
        $scope.loadProviders = function loadProviders() {
            hiddenGamesService.getProviders().then(function (response) {
                    if (response.status === "ok") {
                        $scope.providers = angular.copy(response.items);
                        $scope.providers.unshift({
                            providerTitle: "",
                            provider: ""
                        });
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                }
            );
        };

        $scope.initDateTimestamp = function initDateTimestamp(index) {
            $scope.vm.dateTimestamp = $scope.pageData.customFields[index].value;
            $scope.handleChangeOfTimestamp = function handleChangeOfTimestamp(dateTime, dateToSave) {
                $scope.pageData.customFields[index].value = dateToSave;
            };
        };


        $scope.changeCountries = function changeCountries(isExcluded) {
            var firstKey = isExcluded? 'excluded_countries': 'included_counties';
            var secondKey = isExcluded? 'included_counties': 'excluded_countries';
            if ($scope.pageData[firstKey] && $scope.pageData[firstKey].length > 0 && $scope.pageData[secondKey] && $scope.pageData[secondKey].length > 0) {
                $scope.pageData[secondKey] = [];
            }
        };

        /**
         * Copy to clipboard given string
         * @param str
         */
        $scope.copyToClipboard = function copyToClipboard(str) {
            Utils.copyToClipboard(str);
            $timeout(function () {
                logger.logSuccess("Image URL successfully copied to clipboard")
            }, 100);
        };
    }
]);
